<template>
    <div class="news-index" id="newIndex" v-loading="loading" style="height: auto;">
        <div v-for="(news, i) in newsList" :key="i" class="news-item">
            <el-image class="news-cover" :src="news.coverUrl"></el-image>

            <div style="flex: 1; overflow: hidden;">
                <div class="news-title">
                    <router-link :to="'/newsView/detail?itemId=' + news.id">{{ news.title }}</router-link>
                </div>
                <div class="news-info">
                    <span>来源：橙讯</span>
                    <span>{{ $tools.formatDate(news.publishTime) }}</span>
                </div>
                <div class="news-summary">
                    {{ news.textBody }}
                </div>
                <el-button class="news-btn" round @click="goToThisNews(news)"> 查看详情 </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsIndex',
    data() {
        return {
            loading: false,
            newsList: []
        }
    },
    methods: {
        goToThisNews(news) {
            this.$router.push({
                path: '/newsView/detail',
                query: {
                    itemId: news.id
                }
            })
        }
    },
    activated() {
        this.loading = true
        this.$http({
            url: '/v1/content/catalog',
            method: 'get',
            params: {contentId: this.$route.query.contentId}
        }).then(res => {
            this.newsList = res
            if (window.parent && window.parent.setIframeHeight) {
                this.$nextTick(() => {
                    const realHeight = document.getElementById('newIndex').scrollHeight
                    window.parent.setIframeHeight(realHeight)
                })
            }
            this.loading = false
        }).catch(err => {
            console.info(err)
            this.loading = false
        })
    }
}
</script>

<style lang="scss">
.news-index {
    padding: 0 24px;
    .news-item {
        display: flex;
        padding: 24px 0;
        width: 100%;

        .news-cover {
            width: 218px;
            height: 168px;
            margin-right: 24px;
        }

        .news-title {
            font-size: 24px;

            a {
                color: #333;
                color: inherit;
                text-decoration: none;
                outline: none;
                cursor: pointer;
            }
            /*正常的未被访问过的链接*/
            a:link {
                text-decoration: none;
            }
            /*已经访问过的链接*/
            a:visited {
                text-decoration: none;
            }
            /*鼠标划过(停留)的链接*/
            a:hover {
                text-decoration: none;
                -webkit-tap-highlight-color: transparent;
            }
            /* 正在点击的链接*/
            a:active {
                text-decoration: none !important;
            }
        }

        .news-info {
            font-size: 13px;
            color: #666;
            margin-top: 8px;
        }

        .news-info span:first-child {
            margin-right: 30px;
        }

        .news-summary {
            font-size: 15px;
            margin-top: 12px;
            line-height: 1.5;
            margin-bottom: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .el-button {
            border-color: #FF6722;
            color: #FF6722;
        }

        .el-button:focus, .el-button:hover {
            color: white;
            background-color: #FF6722;
        }

        @media (max-width: 420px) {
            .news-cover {
                width: 40%;
                height: auto;
                margin-right: 12px;

                .el-image__error, .el-image__inner, .el-image__placeholder {
                    width: 100%;
                    height: auto;
                }
            }

            .news-title {
                font-size: 16px;
            }

            .news-info {
                font-size: 11px;
            }

            .news-summary {
                font-size: 12px;
                line-height: 1.5;
                display: block;
                white-space: nowrap;
                margin-bottom: 0;
            }

            .el-button {
                display: none;
            }
                
        }

    }

    .news-item + .news-item {
        border-top: 1px solid #d9d7d7;
    }

}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue